// extracted by mini-css-extract-plugin
export default {"FormControl":"Textarea_FormControl__qXkZz","None":"Textarea_None__e06xX"};